U = window.U || {};
U.Index = U.Index || {};
U.Util = U.Util || {};
U.Global = U.Global || {};
U.Blog = U.Blog || {};
U.Settings = U.Settings || {
	easing: 'easeInOutExpo'
};


U.Util.createCookie = function(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

U.Util.readCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

U.Global.initUnloadHandler = function() {
	if (window.is_safari) {
		// only on safari, beforeunload doesn't fire..
		// but I also know that this method causes a dialog in older browsers.
		window.onbeforeunload = function() {
			$("html").addClass('is-unloading');
		};
	}
	$(window).on('beforeunload', function() {
		// $('html').fadeOut('normal');
		$("html").addClass('is-unloading');
	})
	// $('html').fadeIn('normal');
	$("html").addClass('is-loading');
}

U.Global.initNewsletterPopup = function() {
	var cookieName = 'newsletter-closed';
	var $modal = $(".newsletter-modal-wrapper");
	if (! U.Util.readCookie(cookieName) == true) {
		_.delay(function() {
			$modal.fadeIn();
		}, 7000);

		// close modal if clicked anywhere but in modal
		$(document).on('click', function(ev) {
			if ($(ev.target).closest('.newsletter-modal').length == 0) {
				closeModal();
			}
		});
	}

	function closeModal() {
		U.Util.createCookie(cookieName, true);
		$modal.fadeOut();
	}
}

U.Global.initFastScroll = function() {
	var body = document.body,
    timer;

	window.addEventListener('scroll', function() {
	  clearTimeout(timer);
	  if(!body.classList.contains('disable-hover')) {
	    body.classList.add('disable-hover')
	  }

	  timer = setTimeout(function(){
	    body.classList.remove('disable-hover')
	  }, 500);
	}, false);
}

U.Global.initNavbar = function() {
	// scrollfix is currently firing too late by about 90px; why?


}

U.Global.init = function() {
	if (!window.is_mobile) {
		U.Global.initNewsletterPopup();
	}
	U.Global.initUnloadHandler();
	U.Global.initNavbar();
}

U.Index.init = function() {
}

U.Blog.init = function() {
	// remove blog links; the detail posts are for SEO only.
	$(".blog-image").each(function() {
		$(this).removeAttr('href');
	});
}

/*
U.Product.GalleryInit = function() {

}
*/

handlerFunctions = {}

$(function() {
	U.Global.init();
	U.Blog.init();

	$("[yt-handler]").each(function() {
		var handler = $(this).attr('yt-handler');
		var handlerFunc = new handlerFunctions['collectionSlideHandler']($(this));
	})
})

handlerFunctions.collectionSlideHandler = function($element) {
	var self = this;
	var sc = this;

	// $element is always bespoke
	sc.init = function() {
		self.$content = $element.find('[yt-content]');
		self.$content.hide();

		// register click handlers
		$clicks = $element.find('[yt-click]');
		$clicks.on('click', function() {
			eval($(this).attr('yt-click'));
		});

		(function Subnav() {
			var $nav = $element.find('.product-nav');
			var $slides = $element.find('.product-slide');
			$slides.on('scrollSpy:enter', function() {
			    console.log('enter:', $(this).attr('id'));
			    var $spyNavElement = $element.find('[spy=' + $(this).attr('id') + ']');
			    $(".product-nav-item").removeClass('is-active');
			    $spyNavElement.addClass('is-active');
			});

			$slides.on('scrollSpy:exit', function() {
			    console.log('exit:', $(this).attr('id'));
			});

			$('.product-slide').scrollSpy();

			// or you could do this:
			// $.scrollSpy($('.tile'));
			// or this
			// $('.tile').each(function(i, element) {
			//      $.scrollSpy(element);
			// });
		})()
	}
	sc.reinitialize = function() {
		// reinitialize all dependents, which means... galleries

	}
	sc.shopNow = function() {
		sc.showContent();
		var centerTarget = ($element.find('.product-buy').offset().top + $element.find('.product-buy').height()/2) - ($(window).height()/2);
		// to center this.. we need to go to center position minus
		sc.scrollTo(centerTarget);
	}
	sc.viewFilm = function() {
		sc.showContent();
		var centerTarget = $element.find('.play-video').offset().top - ($(window).height()/2);
		// to center this.. we need to go to center position minus
		sc.scrollTo(centerTarget);

	}
	sc.scrollTo = function(offset) {
		_.delay(function() {
			$('html, body').animate({
				scrollTop: offset - (90/2)  // minus navbar offset
			}, 1500);
		}, 100);
	}
	sc.showContent = function() {
		// hide all other slides. If slide is open, we'll need to adjust the animation targets by that amount.
		if (!self.$content.is(':visible')) {
			self.$content.slideDown(1500, 'easeInOutExpo');
			return true;
		} else {
			self.$content.slideUp();
			return false;
		}
	}
	sc.init();
}



function Subnav($root) {
	function init() {
		console.log("Initializing subnav");
	}
	return {
		reinitialize: function() {

		}
	}
}


// components = [Subnav, Buy, Story, Lookbook];

// $(window).on('resize', function() {
// 	for (var i = components.length - 1; i >= 0; i--) {
// 		components[i].reinitialize();
// 	};
// });
